import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useAppSelector } from "../../../../../hook/store";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { logout } from "../../../../../utilitie/Auth";
import ChangePasswordModal, {
  IChangePasswordFormValues,
} from "../../../Modal/ChangePasswordModal";
import { useModalState } from "../../../Modal";
import { useChangePassword } from "../../../../../hook/query/auth";
import { useSnackbar } from "notistack";
import { EHelperText } from "../../../../../utilitie/validation";
import { relative } from "path";
import PowerSettingsNewTwoToneIcon from '@mui/icons-material/PowerSettingsNewTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';

export default function AvatarMenu() {
  const { enqueueSnackbar } = useSnackbar();
  const avatar = useAppSelector((state) => state.AuthInfo.avatar);
  const userName = useAppSelector((state) => state.AuthInfo.username);
  const firstName = useAppSelector((state) => state.AuthInfo.firstname);
  const lastName = useAppSelector((state) => state.AuthInfo.lastname);
  const email = useAppSelector((state) => state.AuthInfo.email);
  const displayName = [firstName, lastName].filter(Boolean).join(' ') || userName;

  const { mutateAsync: changePassword, isLoading: changePasswordLoading } =
    useChangePassword();

  const [passwordModalState, setPasswordModalState, togglePasswordModalState] =
    useModalState();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangePasswordConfirm = async (
    values: IChangePasswordFormValues
  ) => {
    await changePassword(values)
      .then((data) => {
        let status = data.status as unknown as boolean | number;
        if (status !== true) {
          return enqueueSnackbar(
            EHelperText.AN_ERROR_OCCURRED + EHelperText.PASSWORD,
            { variant: "error" }
          );
        }
        enqueueSnackbar("เปลี่ยนรหัสผ่านสำเร็จ", { variant: "success" });
        togglePasswordModalState(false);
      })
      .catch((error) => {
        enqueueSnackbar(EHelperText.AN_ERROR_OCCURRED + EHelperText.PASSWORD, {
          variant: "error",
        });
      });
  };

  return (
    <>
      <ChangePasswordModal
        {...passwordModalState}
        loading={changePasswordLoading}
        onConfirm={handleChangePasswordConfirm}
        onClose={() => togglePasswordModalState(false)}
      />
      <div>
        <ListItemButton
          sx={{
            border: "1px solid transparent",
            ":hover": {
              bgcolor: "primary.light",
              borderRadius: 2,
              border: (theme) => `1px solid ${theme.palette.primary.main}`,
              color: "primary.dark",
              "& .MuiSvgIcon-root": {
                color: "primary.dark",
              },
            },
            mx: 1,
            mb: 0.5,
            p: 0,
            borderRadius: 2,
            position: "relative",
          }}
          role="button"
          id="avatar-menu"
          aria-controls={open ? "avatar-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <ListItemIcon
            sx={{ minWidth: "48px", m: 0, p: (t) => t.spacing(1.5, 2.85) }}
          >
            <Avatar src={avatar} alt="avatar" sx={{ width: 28, height: 28 }} />
          </ListItemIcon>
          <ListItemText
            primary={displayName}
            secondary={email || undefined}
            primaryTypographyProps={{
              fontSize: '0.82rem',
              fontWeight: 600,
              noWrap: true,
              lineHeight: 1.3,
            }}
            secondaryTypographyProps={{
              fontSize: '0.68rem',
              noWrap: true,
              lineHeight: 1.3,
              color: 'text.disabled',
            }}
          />
        </ListItemButton>
        <Menu
          id="avatar-menu"
          sx={{ position: "absolute", left: "210px" }}
          MenuListProps={{
            "aria-labelledby": "avatar-menu-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem
            onClick={() => {
              togglePasswordModalState(true);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon sx={{ minWidth: 24, m: 0, p: 1.5 }}>
              <LockOpenTwoToneIcon />
            </ListItemIcon>
            <ListItemText primary="เปลี่ยนรหัสผ่าน" />
          </MenuItem>
          <MenuItem onClick={logout}>
            <ListItemIcon sx={{ minWidth: 24, m: 0, p: 1.5 }}>
              <PowerSettingsNewTwoToneIcon />
            </ListItemIcon>
            <ListItemText primary="ออกจากระบบ" />
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}
